import { render } from "./Konten.vue?vue&type=template&id=0a548790"
import script from "./Konten.vue?vue&type=script&lang=js"
export * from "./Konten.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__